import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-quiz-answer-option',
  templateUrl: './view-quiz-answer-option.component.html',
  styleUrls: ['./view-quiz-answer-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewQuizAnswerOptionComponent implements OnInit {

  @Input()
  correct: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
